import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";
import * as types from "@/app/types";

export default class APIRecovery extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  postToken = async (
    token: string,
    { ...body }: types.RecoveryRequest,
  ): Promise<any> => {
    let res = await this._fetch({
      url: `/users/recovery/${token}`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
